import * as Barlow from "fonts/Barlow/Barlow-Medium.ttf";

/**
 *
 * @param {(loaded: boolean) => void} setFontLoaded
 */
export const loadBarlow = async (setFontLoaded) => {
    try {
        const font = new FontFace("Barlow", `url(${Barlow})`);
        await font.load();
        document.fonts.add(font);
        setFontLoaded(true);
    } catch (err) {
        console.error("error loading font: ", err);
    }
};
